import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';
import { ICategory, IRoom} from '../model/room.model';
import { LiveService } from './live.service';


@Injectable({
  providedIn: 'root'
})
export class CategorySearchService {
  private baseUrl;
  public projectId: string;
  private searchUrl: string;

  constructor(protected http: HttpClient, protected liveService: LiveService) {
    this.baseUrl = environment.serviceUrl;
  }

  loadSearchUrl(): void {
    this.http.get<any[]>(`${this.baseUrl}/bifrost/api/projects/${this.projectId}/configs`, {
      params: {
        key: 'LIVE_CATEGORY_SEARCH_ADAPTOR_URL',
        groupName: 'live'
      },
      observe: 'response'
    }).subscribe(res => {
      this.searchUrl = res.body[0].value;
    });
  }

  search(name?: string, room?: IRoom): Observable<HttpResponse<ICategory[]>> {
    const params = {};

    if (room.ref1) {
      params['ref1'] = room.ref1;
    }
    if (room.ref2) {
      params['ref2'] = room.ref2;
    }
    if (room.ref3) {
      params['ref3'] = room.ref3;
    }
    if (room.ref4) {
      params['ref4'] = room.ref4;
    }
    if (room.ref5) {
      params['ref5'] = room.ref5;
    }
    if (room.ref6) {
      params['ref6'] = room.ref6;
    }
    if (room.ref7) {
      params['ref7'] = room.ref7;
    }
    if (room.ref8) {
      params['ref8'] = room.ref8;
    }
    if (room.ref9) {
      params['ref9'] = room.ref9;
    }
    if (room.ref10) {
      params['ref10'] = room.ref10;
    }
    if (name) {
      params['name'] = name;
    }
    if (room.shopId) {
      params['shopId'] = room.shopId;
    }
    if (room.user) {
      params['user'] = room.user;
    }
    if (room.tags && room.tags.length > 0) {
      params['tags'] = room.tags.join(',');
    }

    return this.http.get<ICategory[]>(`${this.searchUrl}`, {
      params: params,
      observe: 'response'
    });
  }
}
